/**
 * @generated SignedSource<<828c676fe2298ef5772ecffc4cebad17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentPixAutomaticLinkShareButton_subscription$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
    readonly projectType: string | null | undefined;
  } | null | undefined;
  readonly customer: {
    readonly phone: string | null | undefined;
  } | null | undefined;
  readonly pixRecurring: {
    readonly paymentLinkUrl: string | null | undefined;
  } | null | undefined;
  readonly value: number | null | undefined;
  readonly " $fragmentType": "PaymentPixAutomaticLinkShareButton_subscription";
};
export type PaymentPixAutomaticLinkShareButton_subscription$key = {
  readonly " $data"?: PaymentPixAutomaticLinkShareButton_subscription$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentPixAutomaticLinkShareButton_subscription">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentPixAutomaticLinkShareButton_subscription",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PixRecurring",
      "kind": "LinkedField",
      "name": "pixRecurring",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paymentLinkUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phone",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PaymentSubscription",
  "abstractKey": null
};

(node as any).hash = "eca1c38ed5bc42c246d9ea6718d854bc";

export default node;
